import { Moment } from "moment";
import * as moment from "moment";
import { InternationalisationService } from "../forked/angular-internationalisation";
import { CoreMomentFormat } from "../languages/momentFormat";
import { environment } from "../../../environments/environment";
import { DateFormatTyps } from "./contentTypes";

export default class DateManager {
  public static MinYMD = 19500101;
  public static MinHMS = 0;

  /** Wandelt bis zu zwei Integer YMD und HMS zu einem Moment
* @param YMD Datum als int im Format YYYYMMDD
* @param HMS Zeit im Format HHMMSS
* @returns Jetzt mit übergebenen Datum (wenn nicht kleiner 1) und übergebener Uhrzeit (wenn nicht kleiner 0)
*/
  public static GetMomentFromInt(YMD: number, HMS: number = -1): Moment {
    const me = this;
    const mom = moment();
    if (YMD < me.MinYMD) {
      YMD = me.MinYMD;
    }
    if (HMS < me.MinHMS) {
      HMS = me.MinHMS;
    }

    mom.year(YMD / 10000 % 10000)
      .month(((YMD / 100) % 100) - 1) // -1: month is 0 based
      .date(YMD % 100);
    mom.hours((HMS / 10000) % 100)
      .minutes((HMS / 100) % 100)
      .seconds(HMS % 100);
    return mom;
  }

  // GetYMDFromMoment
  public static GetYMDFromMoment(mom): number {
    let ymd = mom.year() * 10000;
    ymd += (mom.month() + 1) * 100; // month is 0 based
    ymd += mom.date();
    return ymd;
  }

  // GetHMSFromMoment
  public static GetHMSFromMoment(MOM): number {
    let hms = MOM.hours() * 10000;
    hms += MOM.minutes() * 100;
    hms += MOM.seconds();
    return hms;
  }

  // #veraltet use GetMomentFromInt
  // #GetJSDateFromInt
  public static GetJSDateFromInt(YMD: number, HMS: number = -1) {
    const me = this;
    const mom = me.GetMomentFromInt(YMD, HMS);
    return mom.toDate();
  }

  // veraltet use GetYMDFromMoment
  // GetYMDFromJSDate
  public static GetYMDFromJSDate(JSD) {
    const me = this;
    return me.GetYMDFromMoment(moment(JSD));
  }

  // veraltet use GetHMSFromMoment
  // GetHMSFromJSDate
  public static GetHMSFromJSDate(JSD) {
    const me = this;
    return me.GetHMSFromMoment(moment(JSD));
  }

  public static getLangFormat(): object {
    const lang = InternationalisationService.locale;
    const langFormat = CoreMomentFormat[lang];
    return langFormat;
  }

  public static MomentAsString(mom: Moment, formatType: number | string): string {
    const me = this;
    const lang = InternationalisationService.locale;
    const langFormat = CoreMomentFormat[lang];
    let dateFormat: string;
    if (typeof formatType === "string") {
      dateFormat = formatType;
    } else {
      dateFormat = langFormat[me.getDateFormatKey(formatType)];
    }
    return mom.locale(lang).format(dateFormat);
  }

  public static MomentDateTimeFormatter(mom: Moment, hasDate: boolean, hasTime: boolean): string {
    const me = this;
    const lang = InternationalisationService.locale;
    const langFormat = CoreMomentFormat[lang];
    let result: string;
    if (hasDate && hasTime) {
      result = mom.locale(lang).format(langFormat[me.getDateFormatKey(DateFormatTyps.DDMMYYYY_HHMM)]);
    } else if (hasDate) {
      result = mom.locale(lang).format(langFormat[me.getDateFormatKey(DateFormatTyps.DDMMYYYY)]);
    } else if (hasTime) {
      result = mom.locale(lang).format(langFormat[me.getDateFormatKey(DateFormatTyps.HHMM)]);
    } else {
      result = "";
    }
    return result;
  }

  private static getDateFormatKey(formatType: number) {
    return "dateFormat_" + formatType;
  }

  public static materialDatePickerFormat(): any {
    const me = this;
    const lang = InternationalisationService.locale;
    const langFormat = CoreMomentFormat[lang];
    return {
      parse: {
        dateInput: langFormat[DateManager.getDateFormatKey(environment.MaterialDatePickerFormat)]
      },
      display: {
        dateInput: langFormat[DateManager.getDateFormatKey(environment.MaterialDatePickerFormat)],
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: langFormat[DateManager.getDateFormatKey(environment.MaterialDatePickerFormat)],
        monthYearA11yLabel: "MMMM YYYY",
      },
    };
  }
}
